import { loanProcessingDefinitionsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ACTION_ARITHMETIC_OPERATIONS_ACTION_TYPE = createNamedActions(
  'loanActionArithmeticOperations',
  {
    GET_LOAN_ACTION_ARITHMETIC_OPERATIONS_SCHEMA: 'GET_LOAN_ACTION_ARITHMETIC_OPERATIONS_SCHEMA',
  },
);

export const getLoanActionArithmeticOperationsSchemaAction = catchAsyncActionError(
  () => async dispatch => {
    const { data } =
      await loanProcessingDefinitionsApi.getLoanActionArithmeticOperationsExpressionDefinition();

    return dispatch({
      type: LOAN_ACTION_ARITHMETIC_OPERATIONS_ACTION_TYPE.GET_LOAN_ACTION_ARITHMETIC_OPERATIONS_SCHEMA,
      payload: data,
    });
  },
);
